import { useCallback } from 'react'
import axios from 'axios'

import { PopupAction, PopupEvent, PopupType } from '@/types/api/events'

export const usePopupTracking = (popupType: PopupType) => {
  const isLocalhost =
    typeof window !== 'undefined' && window.location.hostname === 'localhost'

  const trackPopupEvent = useCallback(
    async (action: PopupAction) => {
      if (isLocalhost) {
        return
      }

      try {
        const event: PopupEvent = {
          eventType: 'click',
          objectType: popupType,
          objectName: `Overlay_Popup_${action}`,
          timestamp: new Date().toISOString(),
          metadata: {
            pageUrl: window.location.href,
            deviceType: navigator.userAgent.includes('Mobile')
              ? 'mobile'
              : 'desktop'
          }
        }

        await axios.post('/api/track-events', event, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
      } catch (error) {
        console.error('Failed to track popup event:', error)
      }
    },

    [popupType, isLocalhost]
  )

  return {
    trackClose: () => trackPopupEvent('Close'),
    trackConfirm: () => trackPopupEvent('Confirm'),
    trackDownload: () => trackPopupEvent('Download')
  }
}
